// extracted by mini-css-extract-plugin
export default {"button":"Kp-z","reviewSort":"Lp-z"};